import type { IShopifyPageAssignedData } from '~/modules/shopify';
import type { IAssetTemplateAssigned } from '../types';

export const mappingShopifyPageAssigned = (
  data: IShopifyPageAssignedData,
): IAssetTemplateAssigned => {
  const urlParts = data.url.split('/').filter((part) => part);
  const path = urlParts.slice(2).join('/');
  return {
    ...data,
    fullPath: path,
    thumbnail: data.thumbnail || '',
  };
};
